var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:{ overlay: _vm.overlay }},[_c('h1',[_vm._v("Young Voice")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo-jv",attrs:{"src":"images/logo-yv.svg","alt":"logo-yv"}}),_c('img',{staticClass:"logo-njr",attrs:{"src":"images/njr-logo-liggend.svg","alt":"logo-njr"}})])
}]

export { render, staticRenderFns }